import { Checkbox } from "@/components/ui/checkbox";

export function FieldPicker({ fields, selected, toggle, toggleGroup }) {
  const groups = fields.reduce((acc, f) => {
    (acc[f.group] = acc[f.group] || []).push(f);
    return acc;
  }, {});
  const entries = Object.entries(groups);
  if (!entries.length) return <p className="py-10 text-center text-sm text-muted-foreground" data-testid="export-no-fields">No fields match your search.</p>;
  return (
    <div className="space-y-5" data-testid="export-field-list">
      {entries.map(([group, items]) => {
        const all = items.every((f) => selected.has(f.key));
        return (
          <section key={group}>
            <div className="mb-2 flex items-center justify-between">
              <h4 className="eyebrow text-gold">{group}</h4>
              <button onClick={() => toggleGroup(items, !all)} data-testid={`export-group-toggle-${group}`} className="text-xs font-semibold text-muted-foreground transition-colors hover:text-foreground">
                {all ? "Clear group" : "Select group"}
              </button>
            </div>
            <div className="grid gap-1.5 sm:grid-cols-2">
              {items.map((f) => (
                <label key={f.key} data-testid={`export-field-${f.key}`} className={`flex cursor-pointer items-center gap-2.5 rounded-xl border px-3 py-2 text-sm transition-colors ${selected.has(f.key) ? "border-gold/60 bg-gold/5" : "border-border hover:bg-secondary/60"}`}>
                  <Checkbox checked={selected.has(f.key)} onCheckedChange={() => toggle(f.key)} data-testid={`export-field-checkbox-${f.key}`} />
                  <span className="min-w-0 flex-1 truncate">{f.label}</span>
                  {["id_upload", "file", "file_multiple", "image", "signature"].includes(f.type) && <span className="rounded-full bg-secondary px-2 py-0.5 text-[10px] font-semibold uppercase text-muted-foreground">Link</span>}
                </label>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
